module.exports = __webpack_public_path__ + "img/rules_6.51715616.png";